// Persists exam text highlights to localStorage, per form run and per piece of text.
// Key format:   xams_hl_<formRunGuid>_<scope>      (scope e.g. "q123" for a question, "s45" for a section's scenario)
// Value format: JSON array of {start, end} char offsets into the text's textContent, sorted and non-overlapping
//
// Originally by Mark Burton (HD 9205, text 5 cs:3263) - ported here and generalised to any scope so
// the Scenario pane can share it.

const PREFIX = 'xams_hl';

const getKey = (formRunGuid, scope) => `${PREFIX}_${formRunGuid}_${scope}`;

const loadHighlights = (formRunGuid, scope) => {
	try {
		const raw = localStorage.getItem(getKey(formRunGuid, scope));
		return raw ? JSON.parse(raw) : [];
	} catch (e) {
		return [];
	}
};

const saveHighlights = (formRunGuid, scope, highlights) => {
	try {
		localStorage.setItem(getKey(formRunGuid, scope), JSON.stringify(highlights));
	} catch (e) {
		// localStorage unavailable - highlights just won't survive a reload
	}
};

// merges the new range with any it overlaps or touches, so highlighting across an existing
// highlight extends it rather than nesting one <mark> inside another
const addHighlight = (formRunGuid, scope, start, end) => {
	const merged = {start, end};
	const others = [];

	loadHighlights(formRunGuid, scope).forEach((h) => {
		if (h.end >= merged.start && h.start <= merged.end) {
			merged.start = Math.min(merged.start, h.start);
			merged.end = Math.max(merged.end, h.end);
		} else {
			others.push(h);
		}
	});

	saveHighlights(formRunGuid, scope, [...others, merged].sort((a, b) => a.start - b.start));
};

const removeHighlight = (formRunGuid, scope, start, end) => {
	const updated = loadHighlights(formRunGuid, scope).filter((h) => !(h.start === start && h.end === end));
	saveHighlights(formRunGuid, scope, updated);
};

export {loadHighlights, addHighlight, removeHighlight}
